import PWAServiceWorkerCleanup from "@/components/PWAServiceWorkerCleanup";
import SimpleToast from "@/components/SimpleToast";
import { useSwipeToBack } from "@/hooks/useSwipeToBack";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProps } from "next/app";
import Head from "next/head";
import { useState } from "react";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "../components/ThemeProvider";
import { OnboardingNewUserProvider } from "../contexts/OnboardingContext";
import { PWAProvider } from "../contexts/PWAContext";
import { RootProvider } from "../contexts/rootContext";
import "../styles/globals.css";
import { useAnalytics } from "../utils/analytics";

const App = ({ Component, pageProps }: AppProps) => {
  const [queryClient] = useState(() => new QueryClient());
  useSwipeToBack();

  // Initialize analytics: UTM capture + page view tracking
  useAnalytics();

  // App→ThemeProvider→PWAProvider→RootProvider→OnboardingNewUserProvider→Homeの順番に解決されている
  return (
    <>
      <Head>
        <title>ホーム - X裏垢マッチングサービス「ウラハル」</title>
        <link rel="preload" as="image" href="/images/add-uraharu.svg" />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no, viewport-fit=cover"
        />
      </Head>
      <ThemeProvider>
        <PWAServiceWorkerCleanup />
        <PWAProvider>
          <QueryClientProvider client={queryClient}>
            <RootProvider>
              <OnboardingNewUserProvider>
                <Component {...pageProps} />
                <SimpleToast />
              </OnboardingNewUserProvider>
            </RootProvider>
          </QueryClientProvider>
        </PWAProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
